import JDILogin from '@/app/login/index.login';

interface loginParams {
  returnUrl?: string;
}
/**
 登录后执行回调函数，如未登录，则自动打开登录框，登录后继续执行回调函数
 用法:
 callAfterLogin(() => {
 }
*/
export default async function callAfterLogin(callbackFunc: () => void, params?: loginParams) {
  const userInfo = await JDILogin.getInstance().getUserInfo();
  if (userInfo.isLoggedIn) {
    typeof callbackFunc === 'function' && callbackFunc();
  } else {
    JDILogin.getInstance().jumpToLoginPage(params);
  }
}
